const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/VersicherungsangabeField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const VersicherungsangabeField = generateMetaKatDropDownField(
    '36ece6c1-3a56-4974-9085-782bea5e3957',
    'VersicherungsangabeField'
);

export default VersicherungsangabeField;
